var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuthenticateFrame',[_c('ar-text',{style:({
      marginBottom: '16px',
    }),attrs:{"text":"Your invitation link has expired","size":"lg","multiple-lines":""}}),_vm._v(" "),_c('ar-text',{style:({
      color: _vm.$arStyle.color.skyBlueGrey700,
      marginBottom: '40px',
    }),attrs:{"text":"Please contact your manager to request a new link","size":"sm","multiple-lines":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }